<template>
  <nav
    class="disease-type-v2-sub"
    :style="`
      ${isFixed ? 'height: 62px;' : ''}
      ${insureList.length < 2 ? 'top: 44px' : ''}
    `"
  >
    <ul
      ref="nav"
      :style="`width: ${width}px;${cssText}`"
      @touchstart="touchstart"
      @touchmove="touchmove"
      @touchend="touchend"
    >
      <li
        v-for="(item, idx) in list"
        :key="`mnt_${idx}`"
        :style="`width: ${item.width}px; ${isFixed ? 'height: 44px' : ''}`"
        :class="idx === value ? 'active' : ''"
        @click="gotoTab(idx)"
      >
        <p :class="(item.totalDiseaseNumber || word) ? '' : 'zero'">
          {{ item.categoryName }}
          <span v-if="(item.totalDiseaseNumber || word) && !isFixed">共{{ item.totalDiseaseNumber || 0 }}种</span>
          <em v-if="item.type" :style="`background: ${tag[item.type - 1].color}`">{{ tag[item.type - 1].title }}</em>
        </p>
      </li>
    </ul>
  </nav>
</template>
<script>
import { buriedSubmit } from 'common/js/common'
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    },
    isFixed: Boolean
  },
  data() {
    return {
      width: window.innerWidth,
      move: 0,
      cssText: '',
      lefts: [0],
      tag: [{
        title: '重疾',
        color: '#FF5000'
      }, {
        title: '中症',
        color: '#FFA428'
      }, {
        title: '轻症',
        color: '#32A6FF'
      }]
    }
  },
  computed: {
    insureList() {
      return this.$parent.list || []
    },
    word() {
      return this.$parent.word || ''
    }
  },
  watch: {
    list: {
      handler(v) {
        if (!v || !v.length) return
        let WW = 0
        v.forEach(item => {
          let ww = 0
          item.categoryName.split('').forEach(letter => {
            ww += /[\u2E80-\uFE4F（）]/.test(letter) ? 15 : 8
          })
          item.width = ww + 20
          WW += ww + 35
          this.lefts.push(WW - 30)
        })
        WW = WW < window.innerWidth ? window.innerWidth : WW
        this.isScroll = WW > window.innerWidth
        this.maxLeft = WW - window.innerWidth
        this.width = WW
      },
      immediate: true
    },
    value: {
      handler(v) {
        let left = this.lefts[v]
        left = left > this.maxLeft ? this.maxLeft : left
        this.cssText = `transform: translate(-${left}px, 0);transition: all 0.3s 0s`
        this.move = -left
      },
      immediate: true
    }
  },
  methods: {
    gotoTab(idx) {
      this.$emit('input', idx)
      const item = this.list[idx] || {}
      buriedSubmit('jbxqfz', {
        id: item.categoryId
      })
    },
    touchstart(ev) {
      if (!this.isScroll) return
      const touch = ev.touches[0]
      this.startX = touch.pageX
    },
    touchmove(ev) {
      if (!this.isScroll) return
      const touch = ev.touches[0]
      const currentX = touch.pageX
      this.dis = currentX - this.startX + this.move
      this.dis = Math.min(this.dis, 0)
      this.dis = Math.max(this.dis, -this.maxLeft)
      this.cssText = `transform: translate(${this.dis}px, 0)`
    },
    touchend() {
      if (!this.isScroll) return
      this.move = this.dis
    },
    reset() {
      this.$emit('input', 0)
      this.cssText = ''
      this.move = 0
    }
  }
}
</script>
<style>
@import './diseaseTypeNew.css';
</style>